// extracted by mini-css-extract-plugin
export default {"container":"iM-z","topReviewHeading":"jM-z","criticalReview":"kM-z","favorableReview":"lM-z","vsSeparator":"mM-z"};